import React from "react";
import objectPath from "object-path";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import mixpanel from "mixpanel-browser";

import { addProductSync } from "../../../../Store/Modules/Menu/Actions";
import { setProductDialogState } from "../../../../Store/Modules/Dialogs/Actions";
import { api } from "../../../../Services/Api";
import { Form } from "./style";

export default function AddProductDialog({ categoryId, onClose, ...props }) {
  const dispatch = useDispatch();
  const [formData, setFormData] = React.useState({ categoryId });
  const [productId, setProductId] = React.useState();

  function handleInputChange(event) {
    const { name, value } = event.target;
    const updatedFormData = { ...formData };
    objectPath.set(updatedFormData, name, value);
    setFormData(updatedFormData);
  }

  function handleAddProduct(event) {
    event.preventDefault();
    mixpanel.track("Add Product");
    api
      .post("/menu/products", formData)
      .then(({ data }) => {
        dispatch(addProductSync(data));
        setProductId(data._id);
        // setFormData({ categoryId: data.categoryId });
        dispatch(
          setProductDialogState("data", {
            productId: data._id,
            printDescription: data.printDescription,
          })
        );
        dispatch(setProductDialogState("show", true));
        handleClose();
      })
      .catch((err) => {
        toast.error("Não foi possível continuar. Por favor atualize a página.");
      })
      .finally(() => {});
  }

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      {!productId && (
        <div>
          {/* <DialogTitle>Adicionando novo produto</DialogTitle> */}
          <DialogContent>
            <Form onSubmit={handleAddProduct}>
              <TextField
                label="Nome do produto"
                name="printDescription"
                value={formData.printDescription}
                onChange={handleInputChange}
                required
                autoFocus
                variant="outlined"
                size="small"
                autoComplete="off"
              />

              <Button type="submit" variant="contained" color="primary">
                Avançar
              </Button>
            </Form>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="default">
              Fechar
            </Button>
          </DialogActions>
        </div>
      )}
    </>
  );
}
